import { render, staticRenderFns } from "./base-column-id.vue?vue&type=template&id=92ea3812&scoped=true&"
import script from "./base-column-id.vue?vue&type=script&lang=js&"
export * from "./base-column-id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ea3812",
  null
  
)

export default component.exports